const scope = "clientLossRstr";
export default scope;
